// @flow

import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '@app/reducers/session';
import Button from '@app/components/button';
import { T } from '@app/components/translation';

import style from './forget-password.module.scss';

export const ForgetPassword = () => {
  const dispatch = useDispatch();

  const handleLogOut = () => {
    dispatch(logout('/recover-account'));
  };

  return (
    <Button
      kind="link"
      onClick={() => handleLogOut()}
      customClass={style.PasswordLink}
    >
      <T
        _str="Forgot your password?"
        _comment="Link text for going to the forgot password from the login page."
      />
    </Button>
  );
};
